import React from 'react';
import { Outlet } from 'react-router-dom';

import Layout from '@/shared/components/Layout';

const AppShell: React.FC = () => (
  <Layout>
    <Outlet />
  </Layout>
);

export default AppShell;
